import ApplicationController from './application_controller'

// IMPORTANT NOTE: Turbo.renderStreamMessage(html) throws errors on turbo-frames.
// This must return a turbo-stream to work correctly.
//
// If turbo-frame needs support, you must parse the html response, pull out the frame
// and replace the element by it's turbo-frame#identifier selector.
export default class extends ApplicationController {
	connect() {
	}

	submit(event) {
		const submitButton = event.currentTarget
		const form = submitButton.closest('form')
		const formData = new FormData(form)

		if (submitButton.name) {
			formData.append(submitButton.name, submitButton.value)
		}

		fetch(form.action, {
			method: form.method,
			body: formData,
		})
		.then(r => r.text())
		.then((html) => {
			Turbo.renderStreamMessage(html)
		 	this.resetSubmitButton(submitButton)
		})

		// Prevent the default form submit
		event.preventDefault();
	}

	resetSubmitButton(element) {
		element.removeAttribute('disabled')
	}
}
